import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpService, ApiResponse } from '../../../core/services/http.service';
import { FidPickerItem } from '../models/fid-picker.interface';

@Injectable({
  providedIn: 'root'
})
export class FidPickerService {
  private readonly endpoint = '/fid-picker';

  constructor(private httpService: HttpService) {}

  // Get FID picker items - returns sample data for demonstration
  getFidPickerItems(): Observable<FidPickerItem[]> {
    // Sample data that matches our FidPickerItem interface
    const sampleItems: FidPickerItem[] = [
      { id: '1', title: 'FID Item 1'  },
      { id: '2', title: 'FID Item 2' },
      { id: '3', title: 'FID Item 3'  },
      { id: '4', title: 'FID Item 4' },
      { id: '5', title: 'FID Item 5'  }
    ];

    // Return sample data (could be replaced with HTTP call later)
    return of(sampleItems);
    
    // For real API, you would use:
    // return this.httpService.get<FidPickerItem[]>(this.endpoint);
  }
} 